"use client";
import { useEffect, useState } from "react";

import classnames from "classnames";

import TextInput from "@stadium/ui/src/components/form/TextInput";
import Label from "@stadium/ui/src/components/form/Label";

import Button from "@stadium/checkout/src/components/shared/buttons";
import { applyCouponCodeApi, removeCouponCodeApi } from "@stadium/checkout/src/api/order";

import style from "./main.module.scss";

const PromoCode = ({
  appliedPromoCode,
  orderId,
  isPromoDisabled = false,
  onSuccessPromoCode,
  isExistingOrder = false,
  className = "",
}) => {
  const [isPromoCodeOpen, setIsPromoCodeOpen] = useState(!!appliedPromoCode);
  const [couponCode, setCouponCode] = useState(appliedPromoCode);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccessMsg, setShowSuccessMsg] = useState(!!appliedPromoCode);
  const [isCouponCodeFieldDisabled, setIsCouponCodeFieldDisabled] = useState(
    isPromoDisabled || !!appliedPromoCode,
  );

  useEffect(() => setError(""), [couponCode]);

  const handleCouponCodeChange = ({ value }) => setCouponCode(value.toLocaleUpperCase());

  const onSuccessCbHandler = (isApplyPromocodeClicked) => {
    onSuccessPromoCode?.();
    isApplyPromocodeClicked ? setShowSuccessMsg(true) : setShowSuccessMsg(false);
    isApplyPromocodeClicked
      ? setIsCouponCodeFieldDisabled(true)
      : setIsCouponCodeFieldDisabled(false);
  };

  const handleApplyPromoCode = () => {
    setIsLoading(true);
    applyCouponCodeApi({
      orderId,
      couponCode,
      successCb: () => onSuccessCbHandler(true),
      errorCb: setError,
    }).finally(() => setIsLoading(false));
  };

  const handleRemovePromoCode = () => {
    if (error) return setCouponCode("");
    if (!couponCode) return;
    setIsLoading(true);
    removeCouponCodeApi({
      orderId,
      couponCode,
      successCb: () => onSuccessCbHandler(false),
      errorCb: setError,
    }).finally(() => {
      setCouponCode("");
      setIsLoading(false);
    });
  };

  const renderSuccessMessage = () => {
    if (!showSuccessMsg) return null;
    return (
      <div className={style.promoMessage}>
        <i /> Promotion Applied
      </div>
    );
  };

  const renderErrorMessage = () => {
    if (!error) return null;
    return <div className={style.promoMessage}>{error}</div>;
  };

  const renderPromoCodeCta = () => {
    if (showSuccessMsg || error)
      return (
        !isExistingOrder && (
          <Button
            styleType="link"
            isLoading={isLoading}
            onClick={handleRemovePromoCode}
            disabled={isLoading}
            fillStroke={"000"}
            className={`${style.button} ${style.removeBtn}`}
          >
            <i className={style.closeIcon} />
          </Button>
        )
      );
    return (
      <Button
        styleType="link"
        isLoading={isLoading}
        onClick={handleApplyPromoCode}
        disabled={isLoading || !couponCode || isPromoDisabled}
        fillStroke={"000"}
        className={`${style.button} ${style.applyBtn}`}
      >
        APPLY
      </Button>
    );
  };

  const renderPromoCodeSection = () => {
    return (
      <div
        className={classnames({
          [style.promoCodeBox]: true,
          [style.boxDisable]: isCouponCodeFieldDisabled,
          [style.withError]: error,
          [style.withSuccess]: !error,
        })}
      >
        <div className={style.promoGroup}>
          <TextInput
            id="couponCode"
            value={couponCode}
            placeholder="Apply promotion"
            onChange={handleCouponCodeChange}
            disabled={isCouponCodeFieldDisabled}
            className={style.promotInputBox}
            autoFocus
            readOnly={isCouponCodeFieldDisabled}
            label={
              <Label showIcon={false} className={style.billLabel}>
                Add Promo Code
              </Label>
            }
          />
          {renderPromoCodeCta()}
        </div>
        {renderSuccessMessage()}
        {renderErrorMessage()}
      </div>
    );
  };

  if (isPromoCodeOpen) return renderPromoCodeSection();

  return (
    <div className={`${style.promoCodeBox} ${className} `}>
      <Button
        styleType="link"
        className={style.applyCodeBtn}
        onClick={() => setIsPromoCodeOpen(true)}
      >
        Apply Promo Code
      </Button>
    </div>
  );
};

export default PromoCode;
